import { Injectable } from "@angular/core";
import { IMenu, IMenuItem } from "./menu.interface";
import { Subject } from "rxjs";
import { MatDialogConfig, MatDialogRef } from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class MenuService {
  private _menu: IMenu = {
    primary: [],
    secondary: [],
  };

  private _itemList: IMenuItem[] = [];
  openDialogRefSubject$: Subject<MatDialogRef<any>> = new Subject<
    MatDialogRef<any>
  >();

  _setMenu(menu: IMenu): void {
    this._menu = menu;
  }

  _addToItemList(menuItem: IMenuItem): void {
    this._itemList.push(menuItem);
  }

  _getItemList(): IMenuItem[] {
    return this._itemList;
  }

  _resetItemList(): void {
    this._itemList.length = 0;
  }

  _getMenu(): IMenu {
    return this._menu;
  }

  _resetMenu(): void {
    this._menu.primary.length = 0;
    this._menu.secondary.length = 0;
  }

  _getDialogConfig(): MatDialogConfig {
    return {
      panelClass: ["adx-plugin-default-dialog-content", "adx-dialog-medium"],
      autoFocus: false,
      maxHeight: "90vh",
    };
  }
}
